import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BiComment } from 'react-icons/bi';
import { FiClock } from 'react-icons/fi';

import { Thumbnail } from '../atoms';

import { AddComment } from './index';

type Props = {
  data: any;
  answers?: null | any[];
  keyId?: string | number;
  canWrite?: boolean;
};

const Comment = ({ data, answers, keyId = 0, canWrite = false }: Props) => {
  const { author, content } = data;
  const [isAddComment, setIsAddComment] = useState<boolean>(false);
  const [showReplies, setShowReplies] = useState<boolean>(false);
  const [showCommentEditor, setShowCommentEditor] = useState<boolean>(false);
  const t = useTranslations();

  return (
    <div data-test={`comment.list.${keyId}`}>
      <div className="w-100">
        <div className="flex justify-between">
          <div className="flex items-center gap-3">
            <Thumbnail path={author?.avatar} name={author.name} className="circle" size="small" />
            {author.name}
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center">
              <FiClock className="mr-1" />
              <span>{new Date(data.dateGmt).toLocaleDateString('pl-PL')}</span>
            </div>
            {answers !== null && (
              <button className="flex items-center gap-1" onClick={() => setShowReplies(!showReplies)}>
                <div className="flex items-center gap-1">
                  {(answers || []).length}
                  <BiComment />
                </div>
                <div className="sr-only">{t('main.main.seeMoreAnswers')}</div>
              </button>
            )}
          </div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: content }} />
        {showReplies && answers !== null && <div className="ml-6">{answers}</div>}
        <div>
          {showCommentEditor && (
            <AddComment
              option="answer"
              postId={data.postId}
              parentId={data.id}
              hideAddComment={() => setShowCommentEditor(false)}
            />
          )}
          <div>
            {showReplies && !showCommentEditor && answers !== null && canWrite && (
              <button
                className="mx-auto flex w-auto items-center justify-center rounded-lg bg-premium-900 p-2 font-bold text-white transition-colors hover:bg-premium-700 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-premium-900 dark:bg-white dark:text-premium-900 dark:hover:bg-premium-900 dark:hover:text-white dark:disabled:hover:bg-white dark:disabled:hover:text-premium-900"
                onClick={() => {
                  setShowCommentEditor(true);
                  setShowReplies(true);
                  setIsAddComment(!isAddComment);
                }}
              >
                {t('main.label.placeholder.answer')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comment;
